export const homeProcessingMessages = [
  'Consultando propostas',
  'Verificando informações',
  'Preparando resposta',
];

export const positionsProcessingMessages = [
  'Salvando suas respostas',
  'Localizando propostas',
  'Verificando fontes públicas',
];

export const politicalMatchProcessingMessages = [
  'Calculando seu posicionamento',
  'Preparando o resumo',
  'Organizando os candidatos',
];
